import { render, staticRenderFns } from "./CreatePurchase.vue?vue&type=template&id=44c25b18&"
import script from "./CreatePurchase.vue?vue&type=script&lang=ts&"
export * from "./CreatePurchase.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports